import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import useEnrollmentModal from '../hooks/useEnrollmentModal';

import { GIButton } from 'app-components';
import { usePermissions } from '@hooks/usePermissions';
import useSetSelectedEnrollment from '@hooks/useSetSelectedEnrollment';
import { IEnrollment } from '../common/types';

const StyledContainer = styled.div`
    justify-content: end;
    display: flex;
    gap: 10px;
    padding: 10px;
`;

interface TransactionActionsProps {
    enrollment: IEnrollment;
}

const TransactionActions: React.FC<TransactionActionsProps> = ({ enrollment }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { canResend834History, canResendLatest834Transaction } = usePermissions();
    const setSelectedEnrollment = useSetSelectedEnrollment();

    const permissions = useSelector((state: any) => state.memberEnrollment?.permissions);
    const { userPermissions } = permissions || {};

    const { handleResendHistory, handleResendTransactions, resendHistory, resendTransactions } = useEnrollmentModal();

    const handleResendHistoryClick = useCallback(() => {
        handleResendHistory(enrollment.encEnrollmentId, resendHistory);
    }, [enrollment.encEnrollmentId, resendHistory]);

    const handleResendTransactionsClick = useCallback(() => {
        handleResendTransactions(enrollment.encEnrollmentId, resendTransactions);
    }, [enrollment.encEnrollmentId, resendTransactions]);

    const onShowPremiumHistoryClick = () => {
        setSelectedEnrollment(enrollment);
        navigate(`${location.pathname}/premiumHistory`);
    };

    return (
        <StyledContainer>
            {userPermissions?.memberEnrlmntPrmHist && (
                <GIButton
                    labelId={'member.enrollment_list.premiumhistory.showPremiumHisotry'}
                    onClickHandler={onShowPremiumHistoryClick}
                    id={'showPremiumHistory'}
                ></GIButton>
            )}
            {canResend834History(userPermissions, enrollment) && (
                <GIButton
                    id="resend834History"
                    labelId="member.enrollment_list.premiumhistory.resend834History"
                    onClickHandler={handleResendHistoryClick}
                />
            )}
            {canResendLatest834Transaction(userPermissions, enrollment) && (
                <GIButton
                    labelId={'member.enrollment_list.premiumhistory.resendLatest834Transaction'}
                    onClickHandler={handleResendTransactionsClick}
                    id={'resendLatest834Transaction'}
                ></GIButton>
            )}
        </StyledContainer>
    );
};

export default TransactionActions;
